import { render, staticRenderFns } from "./brouchor.vue?vue&type=template&id=7fa95f61&scoped=true"
import script from "./brouchor.vue?vue&type=script&lang=js"
export * from "./brouchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa95f61",
  null
  
)

export default component.exports